/* @flow */
import * as React from 'react';

import IconButton from '../IconButton';

export default (props: React.ElementConfig<typeof IconButton>) => (
  <IconButton {...props} isToggle={true} />
);
